import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import MacroCalculator from "@/components/MacroCalculator";
import WhatAreMacros from "@/components/WhatAreMacros";

export default function Macros() {
  return (
    <div className="bg-[#F4F3EF]">
      {/* Hero */}
      <section className="relative bg-[#0A0A0A] text-white grain overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://customer-assets-jt897jd0.emergentagent.net/job_down-test-adjust/artifacts/5knwmx0m_ChatGPT%20Image%20Jul%2025%2C%202026%20at%2004_07_01%20PM.png"
            alt="DTA training"
            className="w-full h-full object-cover opacity-55"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/40 to-black/90" />
        </div>
        <div className="relative dta-container pt-32 pb-24 md:pb-32">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/15 px-3 py-1.5 mb-8">
            <span className="w-1.5 h-1.5 bg-[#8fa8d6] rounded-full animate-pulse" />
            <span className="dta-overline text-[0.6rem] text-white/80">
              Macros calculator. Launching soon
            </span>
          </div>
          <p className="dta-overline text-white/60">Macros</p>
          <h1 className="hero-headline text-5xl md:text-8xl mt-6 max-w-4xl">
            Fuel the<br />process.
          </h1>
          <p className="mt-8 text-lg md:text-xl text-white/70 max-w-2xl leading-relaxed">
            Simple nutrition. No fads. No shame. A calm, honest approach to protein, carbs, fats and calories, built to support training, recovery and the days when progress feels slow.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <Link to="/" className="dta-btn dta-btn-primary">
              Join the waiting list <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
            </Link>
            <Link to="/personal-training" className="dta-btn dta-btn-outline-light">
              See Personal Training
            </Link>
          </div>
        </div>
      </section>

      {/* Calculator */}
      <section className="py-20 md:py-28 bg-[#F4F3EF]">
        <div className="dta-container">
          <div className="max-w-3xl mx-auto mb-10">
            <p className="dta-overline text-navy text-center">DTA Macro Calculator</p>
            <h2 className="section-heading text-4xl md:text-6xl mt-3 text-center">
              Know your numbers.<br />Build your day.
            </h2>
            <p className="mt-5 text-center text-[#272727] max-w-xl mx-auto">
              Weight • Waist • Body Fat • Resting Heart Rate
              <br />
              Everything stays in your browser.
            </p>
            <p className="mt-2 text-center dta-overline text-[0.6rem] text-[#4E5B43]">
              Calculate it · Match it · Eat it · Adjust it
            </p>
          </div>
          <div id="dta-macro-calculator" className="max-w-3xl md:max-w-5xl mx-auto scroll-mt-24">
            <MacroCalculator />
          </div>
        </div>
      </section>

      {/* What are macros — education section with rotating wheel + Simple/Science tabs */}
      <WhatAreMacros calculatorId="dta-macro-calculator" />

      {/* Disclaimer */}
      <section className="py-16 md:py-20 bg-[#F4F3EF]">
        <div className="dta-container max-w-3xl">
          <div className="border border-black/10 p-6 md:p-8 bg-white">
            <p className="dta-overline text-navy">Note</p>
            <p className="mt-3 text-sm text-[#272727] leading-relaxed">
              DTA Macros provides general nutrition guidance to support training and resilience. It is not medical advice, dietetic advice, or a treatment plan. If you have a medical condition, allergy, eating disorder history or any specific dietary requirement, please consult a qualified professional before changing how you eat.
            </p>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 md:py-28 bg-[#0A0A0A] text-white">
        <div className="dta-container flex flex-col md:flex-row md:items-center md:justify-between gap-8">
          <div>
            <p className="dta-overline text-white/50">Be first</p>
            <h2 className="section-heading text-3xl md:text-5xl mt-2">
              Join the waiting list.
            </h2>
            <p className="text-white/60 mt-3 max-w-md">
              Macros guidance launches alongside the DTA personal training programme.
            </p>
          </div>
          <Link to="/" className="dta-btn dta-btn-primary">
            Add me to the list <ArrowRight className="w-4 h-4" strokeWidth={1.5} />
          </Link>
        </div>
      </section>
    </div>
  );
}
